import React, { useEffect, useMemo } from 'react';

import { BlockInfoType } from '../../common-types/BlockInfo.type';
import { PersonalDataConfiguration } from '../../common-types/ScreensConfigurations.type';
import { PersonalDataContainer } from './PersonalData.style';
import { Email } from './Email';

export interface Props {
  personalDataConfig: PersonalDataConfiguration[];
  isEdition?: boolean;
  addEditableBlock?: (block: BlockInfoType) => void;
  onBlockEdit?: React.MouseEventHandler<HTMLDivElement>;
  displayName: string;
  dataTemplateConfig: string;
  testId?: string;
  availableData: Record<string, string | undefined | null>
}

export const PersonalData: React.FunctionComponent<Props> = ({
  personalDataConfig,
  isEdition,
  addEditableBlock,
  onBlockEdit,
  displayName,
  dataTemplateConfig,
  testId,
  availableData,
} : Props) => {
  const dataTemplateType = 'personal-data';

  const computedPersonalData = useMemo<Array<PersonalDataConfiguration & {disabled?:boolean}>>(() => {
    return personalDataConfig
      .filter(({ activated }) => activated)
      .sort(({ position: positionA }, { position: positionB }) => positionA - positionB)
      .map((data: PersonalDataConfiguration & { disabled?: boolean }) => {
        return {
          ...data,
          disabled: typeof availableData[data.key] === 'string'
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- fuck dumb eslint
            // @ts-ignore
            ? availableData[data.key].trim().length > 0
            : false,
        };
      });
  }, [personalDataConfig, availableData]);

  useEffect(
    () => {
      if (addEditableBlock) {
        addEditableBlock({
          blockType: dataTemplateType,
          configPath: dataTemplateConfig,
          label: displayName,
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dataTemplateConfig]
  );

  return (
    <PersonalDataContainer
      isEdition={isEdition}
      data-template-type={dataTemplateType}
      data-display-name={displayName}
      data-config-path={dataTemplateConfig}
      data-testid={testId}
      onClick={onBlockEdit}
    >
      {computedPersonalData.map(({ type, placeholderText, labelHtml, key, disabled }) => {
        switch (type) {
        case 'email':
          return (
            <Email
              name={`personalData.${key}`}
              key={key}
              placeholderText={placeholderText}
              labelHtml={labelHtml}
              disabled={disabled}
            />
          );
        default:
          return null;
        }
      })}
    </PersonalDataContainer>
  );
};
